import { render, staticRenderFns } from "./CreateUserContent.vue?vue&type=template&id=4d9d33a4&"
import script from "./CreateUserContent.vue?vue&type=script&lang=ts&"
export * from "./CreateUserContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports